import { useEffect, useState } from "react";
import {
  Box, Paper, Stack, Typography, Grid, TextField, Button, Divider,
  FormControlLabel, Checkbox, Alert, InputAdornment, IconButton, MenuItem,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import PaymentIcon from "@mui/icons-material/Payment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Swal from "sweetalert2";
import {
  getConfig, salvarConfig, testarEmail, testarWhatsappCfg, testarPix, testarMatricula,
  registrarWebhookBB, consultarWebhookBB, excluirWebhookBB,
} from "../../services/configService";

function Secret({ label, value, onChange }) {
  const [ver, setVer] = useState(false);
  return (
    <TextField fullWidth label={label} type={ver ? "text" : "password"} value={value || ""} onChange={onChange}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={() => setVer((v) => !v)} edge="end" size="small">{ver ? <VisibilityOff /> : <Visibility />}</IconButton>
          </InputAdornment>
        ),
      }} />
  );
}

export default function ConfigPage() {
  const [cfg, setCfg] = useState(null);
  const [salvando, setSalvando] = useState(false);
  const set = (grupo, k, v) => setCfg((p) => ({ ...p, [grupo]: { ...p[grupo], [k]: v } }));

  const carregar = async () => {
    try { setCfg((await getConfig()).data); }
    catch (e) { Swal.fire("Erro", e?.response?.data || e.message, "error"); }
  };
  useEffect(() => { carregar(); }, []);

  const salvar = async () => {
    setSalvando(true);
    try { await salvarConfig(cfg); await Swal.fire("Salvo", "Configurações salvas.", "success"); }
    catch (e) { Swal.fire("Erro", e?.response?.data?.mensagem || e?.response?.data || e.message, "error"); }
    finally { setSalvando(false); }
  };

  const testarEmailFn = async () => {
    const { value: para } = await Swal.fire({
      title: "Testar e-mail", input: "email", inputLabel: "Enviar e-mail de teste para:",
      inputPlaceholder: "voce@exemplo.com", showCancelButton: true, confirmButtonText: "Enviar",
    });
    if (!para) return;
    Swal.fire({ title: "Enviando…", didOpen: () => Swal.showLoading(), allowOutsideClick: false });
    try {
      const { data } = await testarEmail(para);
      if (data.ok) Swal.fire("Enviado!", "E-mail de teste enviado com sucesso.", "success");
      else Swal.fire("Falhou", data.erro || "Não foi possível enviar.", "error");
    } catch (e) { Swal.fire("Erro", e?.response?.data?.mensagem || e.message, "error"); }
  };

  const testarWppFn = async () => {
    const { value: cel } = await Swal.fire({
      title: "Testar WhatsApp", input: "text", inputLabel: "Celular (com DDD)",
      inputPlaceholder: "63 99999-9999", showCancelButton: true, confirmButtonText: "Enviar",
    });
    if (!cel) return;
    Swal.fire({ title: "Enviando…", didOpen: () => Swal.showLoading(), allowOutsideClick: false });
    try {
      const { data } = await testarWhatsappCfg(cel);
      Swal.fire({
        icon: data.Ok ? "success" : "error", title: data.Ok ? "Enviado!" : "Falhou",
        html: `<pre style="text-align:left;white-space:pre-wrap;font-size:12px">Contato: ${data.Contato || "-"}\nStatus: ${data.Status ?? "-"}\nErro: ${data.Erro || "-"}</pre>`,
      });
    } catch (e) { Swal.fire("Erro", e?.response?.data?.mensagem || e.message, "error"); }
  };

  const testarPixFn = async () => {
    const { value: form } = await Swal.fire({
      title: "Testar PIX",
      html:
        `<input id="swal-cpf" class="swal2-input" placeholder="CPF (p/ buscar matrícula e criar boleto)">` +
        `<input id="swal-val" class="swal2-input" placeholder="Valor (ex.: 50.00)">` +
        `<hr/><small>Ou informe direto (pula busca/boleto):</small>` +
        `<input id="swal-mat" class="swal2-input" placeholder="Matrícula (opcional)">` +
        `<input id="swal-bol" class="swal2-input" placeholder="Código do boleto (opcional)">`,
      focusConfirm: false, showCancelButton: true, confirmButtonText: "Gerar PIX",
      preConfirm: () => ({
        cpf: document.getElementById("swal-cpf").value,
        val: document.getElementById("swal-val").value,
        mat: document.getElementById("swal-mat").value,
        bol: document.getElementById("swal-bol").value,
      }),
    });
    if (!form) return;
    Swal.fire({ title: "Gerando PIX de teste…", didOpen: () => Swal.showLoading(), allowOutsideClick: false });
    try {
      const { data } = await testarPix(form);
      Swal.fire({
        icon: data.ok && data.pixCopiaCola ? "success" : "warning",
        title: data.ok && data.pixCopiaCola ? "PIX gerado!" : "Resposta do ERP",
        html: `<pre style="text-align:left;white-space:pre-wrap;font-size:11px;max-height:340px;overflow:auto">`
          + `ok: ${data.ok}\nstatus: ${data.status ?? "-"}\n`
          + `pixCopiaCola: ${data.pixCopiaCola || "(não encontrado)"}\nerro: ${data.erro || "-"}\n`
          + `URL chamada:\n${data.url || "-"}\n\n`
          + `passos:\n${data.diagnostico || "-"}\n`
          + `resposta crua:\n${(data.resposta || "(vazia)").substring(0, 1200)}</pre>`,
      });
    } catch (e) { Swal.fire("Erro", e?.response?.data?.mensagem || e.message, "error"); }
  };

  const mostrarWebhook = (titulo, data) => Swal.fire({
    icon: data.ok ? "success" : "error", title: titulo,
    html: `<pre style="text-align:left;white-space:pre-wrap;font-size:11px;max-height:300px;overflow:auto">`
      + `ok: ${data.ok}\nstatus: ${data.status ?? "-"}\nerro: ${data.erro || "-"}\n\nresposta:\n${data.resposta || "(vazia)"}</pre>`,
  });

  const registrarWebhookFn = async () => {
    const url = (cfg.BB.WebhookUrl || "").trim();
    if (!url) { Swal.fire("Atenção", "Informe a URL do webhook (pública, HTTPS).", "warning"); return; }
    const c = await Swal.fire({
      title: "Registrar webhook no BB?", icon: "question", showCancelButton: true, confirmButtonText: "Registrar",
      html: `O BB passará a notificar em:<br/><code>${url}/pix</code>`,
    });
    if (!c.isConfirmed) return;
    Swal.fire({ title: "Registrando…", didOpen: () => Swal.showLoading(), allowOutsideClick: false });
    try { const { data } = await registrarWebhookBB(url); mostrarWebhook(data.ok ? "Webhook registrado!" : "Falha ao registrar", data); }
    catch (e) { Swal.fire("Erro", e?.response?.data?.mensagem || e.message, "error"); }
  };

  const consultarWebhookFn = async () => {
    Swal.fire({ title: "Consultando…", didOpen: () => Swal.showLoading(), allowOutsideClick: false });
    try { const { data } = await consultarWebhookBB(); mostrarWebhook(data.ok ? "Webhook registrado no BB" : "Nenhum webhook / erro", data); }
    catch (e) { Swal.fire("Erro", e?.response?.data?.mensagem || e.message, "error"); }
  };

  const excluirWebhookFn = async () => {
    const c = await Swal.fire({ title: "Remover webhook do BB?", icon: "warning", showCancelButton: true, confirmButtonText: "Remover" });
    if (!c.isConfirmed) return;
    try { const { data } = await excluirWebhookBB(); mostrarWebhook(data.ok ? "Webhook removido" : "Falha ao remover", data); }
    catch (e) { Swal.fire("Erro", e?.response?.data?.mensagem || e.message, "error"); }
  };

  const testarMatriculaFn = async () => {
    const { value: cpf } = await Swal.fire({
      title: "Testar busca de matrícula", input: "text", inputLabel: "CPF do responsável/aluno",
      inputPlaceholder: "000.000.000-00", showCancelButton: true, confirmButtonText: "Buscar",
    });
    if (!cpf) return;
    Swal.fire({ title: "Consultando SEIBD…", didOpen: () => Swal.showLoading(), allowOutsideClick: false });
    try {
      const { data } = await testarMatricula(cpf);
      const linhas = (data.matriculas || []).map((m) => `${m.NomeAluno || "?"} — mat ${m.Matricula}${m.Turma ? ` — Turma ${m.Turma}` : ""}${m.Idade != null ? ` — ${m.Idade} anos` : ""}`).join("\n");
      Swal.fire({
        icon: (data.matriculas || []).length ? "success" : "warning",
        title: (data.matriculas || []).length ? `${data.matriculas.length} matrícula(s)` : "Nenhuma matrícula",
        html: `<pre style="text-align:left;white-space:pre-wrap;font-size:12px;max-height:320px;overflow:auto">`
          + `habilitado: ${data.habilitado}\nerro: ${data.erro || "(nenhum)"}\n\n${linhas || "(vazio)"}</pre>`,
      });
    } catch (e) { Swal.fire("Erro", e?.response?.data?.mensagem || e.message, "error"); }
  };

  if (!cfg) return <Typography>Carregando…</Typography>;

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h5">Configurações</Typography>
        <Button variant="contained" onClick={salvar} disabled={salvando}>{salvando ? "Salvando…" : "Salvar tudo"}</Button>
      </Stack>

      <Alert severity="info" sx={{ mb: 2 }}>
        Estes valores substituem o <code>appsettings.json</code>. Salve antes de testar — os testes usam a configuração já salva.
      </Alert>

      {/* E-mail */}
      <Paper sx={{ p: 2.5, mb: 2 }}>
        <Stack direction="row" alignItems="center" spacing={1} mb={1}>
          <EmailIcon color="primary" /><Typography variant="h6" sx={{ flexGrow: 1 }}>E-mail (SMTP)</Typography>
          <Button variant="outlined" size="small" onClick={testarEmailFn}>Testar e-mail</Button>
        </Stack>
        <Divider sx={{ mb: 2 }} />
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="Servidor (Host)" value={cfg.Email.Host || ""} onChange={(e) => set("Email", "Host", e.target.value)} /></Grid>
          <Grid size={{ xs: 6, sm: 3 }}><TextField fullWidth label="Porta" value={cfg.Email.Port || ""} onChange={(e) => set("Email", "Port", e.target.value)} /></Grid>
          <Grid size={{ xs: 6, sm: 3 }}>
            <FormControlLabel control={<Checkbox checked={String(cfg.Email.EnableSsl).toLowerCase() === "true"} onChange={(e) => set("Email", "EnableSsl", e.target.checked ? "true" : "false")} />} label="SSL/TLS" />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="Usuário" value={cfg.Email.User || ""} onChange={(e) => set("Email", "User", e.target.value)} /></Grid>
          <Grid size={{ xs: 12, sm: 6 }}><Secret label="Senha" value={cfg.Email.Password} onChange={(e) => set("Email", "Password", e.target.value)} /></Grid>
          <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="Remetente (From)" value={cfg.Email.From || ""} onChange={(e) => set("Email", "From", e.target.value)} /></Grid>
          <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="Nome do remetente" value={cfg.Email.FromNome || ""} onChange={(e) => set("Email", "FromNome", e.target.value)} /></Grid>
        </Grid>
      </Paper>

      {/* WhatsApp */}
      <Paper sx={{ p: 2.5, mb: 2 }}>
        <Stack direction="row" alignItems="center" spacing={1} mb={1}>
          <WhatsAppIcon sx={{ color: "#25D366" }} /><Typography variant="h6" sx={{ flexGrow: 1 }}>WhatsApp (Opa Suite)</Typography>
          <Button variant="outlined" size="small" onClick={testarWppFn}>Testar WhatsApp</Button>
        </Stack>
        <Divider sx={{ mb: 2 }} />
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 8 }}><TextField fullWidth label="URL da API (template/send)" value={cfg.OpaSuite.Url || ""} onChange={(e) => set("OpaSuite", "Url", e.target.value)} /></Grid>
          <Grid size={{ xs: 12, sm: 4 }}><TextField fullWidth label="Canal" value={cfg.OpaSuite.Canal || ""} onChange={(e) => set("OpaSuite", "Canal", e.target.value)} /></Grid>
          <Grid size={{ xs: 12 }}><Secret label="Token (Bearer)" value={cfg.OpaSuite.Token} onChange={(e) => set("OpaSuite", "Token", e.target.value)} /></Grid>
          <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="Template — inscrição enviada" value={cfg.OpaSuite.TemplateInscricaoEnviada || ""} onChange={(e) => set("OpaSuite", "TemplateInscricaoEnviada", e.target.value)} /></Grid>
          <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="Template — documento indeferido" value={cfg.OpaSuite.TemplateDocumentoIndeferido || ""} onChange={(e) => set("OpaSuite", "TemplateDocumentoIndeferido", e.target.value)} /></Grid>
        </Grid>
      </Paper>

      {/* Provedor de PIX */}
      <Paper sx={{ p: 2.5, mb: 2 }}>
        <Stack direction="row" alignItems="center" spacing={1} mb={1}>
          <PaymentIcon color="primary" /><Typography variant="h6">Provedor de PIX</Typography>
        </Stack>
        <Divider sx={{ mb: 2 }} />
        <Grid container spacing={2} alignItems="center">
          <Grid size={{ xs: 12, sm: 5 }}>
            <TextField select fullWidth label="Gerar PIX via" value={(cfg.Pix.Provedor || "erp").toLowerCase()} onChange={(e) => set("Pix", "Provedor", e.target.value)}>
              <MenuItem value="erp">ERP (SEI)</MenuItem>
              <MenuItem value="bb">Banco do Brasil (direto)</MenuItem>
            </TextField>
          </Grid>
          <Grid size={{ xs: 12, sm: 7 }}>
            <Typography variant="caption" color="text.secondary">
              Escolha por qual caminho o PIX é gerado. "Banco do Brasil" gera o PIX direto no banco (sem depender do ERP).
            </Typography>
          </Grid>
        </Grid>
      </Paper>

      {/* PIX — Banco do Brasil */}
      <Paper sx={{ p: 2.5, mb: 2 }}>
        <Stack direction="row" alignItems="center" spacing={1} mb={1}>
          <PaymentIcon color="primary" /><Typography variant="h6" sx={{ flexGrow: 1 }}>PIX — Banco do Brasil</Typography>
          <Button variant="outlined" size="small" onClick={testarPixFn}>Testar PIX</Button>
        </Stack>
        <Divider sx={{ mb: 2 }} />
        <Alert severity="info" sx={{ mb: 2 }}>Gera o PIX direto na API de Cobrança do BB. Em produção pode exigir certificado mTLS (.pfx).</Alert>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="URL OAuth (token)" value={cfg.BB.OAuthUrl || ""} onChange={(e) => set("BB", "OAuthUrl", e.target.value)} placeholder="https://oauth.bb.com.br/oauth/token" /></Grid>
          <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="URL API PIX (base /pix/v2)" value={cfg.BB.ApiUrl || ""} onChange={(e) => set("BB", "ApiUrl", e.target.value)} placeholder="https://api-pix.bb.com.br/pix/v2" /></Grid>
          <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="Client ID" value={cfg.BB.ClientId || ""} onChange={(e) => set("BB", "ClientId", e.target.value)} /></Grid>
          <Grid size={{ xs: 12, sm: 6 }}><Secret label="Client Secret" value={cfg.BB.ClientSecret} onChange={(e) => set("BB", "ClientSecret", e.target.value)} /></Grid>
          <Grid size={{ xs: 12, sm: 6 }}><Secret label="App Key (gw-dev-app-key)" value={cfg.BB.AppKey} onChange={(e) => set("BB", "AppKey", e.target.value)} /></Grid>
          <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="Chave PIX recebedora" value={cfg.BB.ChavePix || ""} onChange={(e) => set("BB", "ChavePix", e.target.value)} /></Grid>
          <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="Scope" value={cfg.BB.Scope || ""} onChange={(e) => set("BB", "Scope", e.target.value)} placeholder="cob.write cob.read pix.read" /></Grid>
          <Grid size={{ xs: 6, sm: 3 }}><TextField fullWidth label="Expiração (s)" value={cfg.BB.ExpiracaoSegundos || ""} onChange={(e) => set("BB", "ExpiracaoSegundos", e.target.value)} placeholder="3600" /></Grid>
          <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="Certificado (.pfx) — caminho no servidor" value={cfg.BB.CertPath || ""} onChange={(e) => set("BB", "CertPath", e.target.value)} /></Grid>
          <Grid size={{ xs: 12, sm: 3 }}><Secret label="Senha do certificado" value={cfg.BB.CertSenha} onChange={(e) => set("BB", "CertSenha", e.target.value)} /></Grid>

          {/* Webhook: baixa automática em tempo real */}
          <Grid size={{ xs: 12 }}>
            <Typography variant="subtitle2" color="primary" sx={{ mt: 1 }}>Webhook (baixa automática em tempo real)</Typography>
            <Divider />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Alert severity="info">
              Registre a URL pública do sistema. O BB vai notificar em <code>{(cfg.BB.WebhookUrl || "<sua-url>")}/pix</code> assim
              que o PIX for pago, e a baixa acontece na hora — sem esperar alguém abrir a tela.
              Exige <b>HTTPS público</b> e o escopo <code>webhook.write</code> na aplicação do BB.
            </Alert>
          </Grid>
          <Grid size={{ xs: 12, sm: 7 }}>
            <TextField fullWidth label="URL do webhook (pública, HTTPS)" value={cfg.BB.WebhookUrl || ""}
              onChange={(e) => set("BB", "WebhookUrl", e.target.value)}
              placeholder="https://eventos.colegiosantacruz.g12.br/api/pix/webhook" />
          </Grid>
          <Grid size={{ xs: 12, sm: 5 }} sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
            <Button variant="contained" size="small" onClick={registrarWebhookFn}>Registrar no BB</Button>
            <Button variant="outlined" size="small" onClick={consultarWebhookFn}>Consultar</Button>
            <Button variant="outlined" size="small" color="error" onClick={excluirWebhookFn}>Remover</Button>
          </Grid>
        </Grid>
      </Paper>

      {/* ERP PIX */}
      <Paper sx={{ p: 2.5, mb: 2 }}>
        <Stack direction="row" alignItems="center" spacing={1} mb={1}>
          <PaymentIcon color="primary" /><Typography variant="h6" sx={{ flexGrow: 1 }}>PIX (ERP)</Typography>
          <Button variant="outlined" size="small" onClick={testarPixFn}>Testar PIX</Button>
        </Stack>
        <Divider sx={{ mb: 2 }} />
        <Alert severity="info" sx={{ mb: 2 }}>
          Use uma <b>URL-modelo</b> com marcadores que serão substituídos automaticamente:
          <code>{" {matricula} "}</code>, <code>{" {instituicao} "}</code>, <code>{" {codigoBoleto} "}</code>,
          <code>{" {valor} "}</code>, <code>{" {cpf} "}</code>.
          <br />Ex.: <code style={{ wordBreak: "break-all" }}>https://sei.catolicaorione.edu.br/webservice/aplicativoSEISV/realizarGeracaoPixContaCorrente/{"{matricula}"}/{"{instituicao}"}/{"{codigoBoleto}"}</code>
        </Alert>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12 }}><TextField fullWidth label="URL-modelo da geração de PIX" value={cfg.ErpPix.Url || ""} onChange={(e) => set("ErpPix", "Url", e.target.value)} /></Grid>
          <Grid size={{ xs: 6, sm: 3 }}>
            <TextField select fullWidth label="Método" value={(cfg.ErpPix.Metodo || "GET").toUpperCase()} onChange={(e) => set("ErpPix", "Metodo", e.target.value)}>
              <MenuItem value="GET">GET</MenuItem>
              <MenuItem value="POST">POST</MenuItem>
            </TextField>
          </Grid>
          <Grid size={{ xs: 6, sm: 3 }}><TextField fullWidth label="Instituição (hdInstituicao)" value={cfg.ErpPix.Instituicao || ""} onChange={(e) => set("ErpPix", "Instituicao", e.target.value)} /></Grid>
          <Grid size={{ xs: 6, sm: 3 }}><TextField fullWidth label="codigoUsuarioLogado" value={cfg.ErpPix.CodigoUsuarioLogado || ""} onChange={(e) => set("ErpPix", "CodigoUsuarioLogado", e.target.value)} /></Grid>
          <Grid size={{ xs: 12, sm: 3 }}><Secret label="Token (Authorization)" value={cfg.ErpPix.Token} onChange={(e) => set("ErpPix", "Token", e.target.value)} /></Grid>

          <Grid size={{ xs: 12 }}><Typography variant="subtitle2" color="primary" sx={{ mt: 1 }}>Geração do boleto</Typography><Divider /></Grid>
          <Grid size={{ xs: 12 }}>
            <TextField fullWidth label="URL gerarBoletoAvulso" value={cfg.ErpPix.BoletoUrl || ""} onChange={(e) => set("ErpPix", "BoletoUrl", e.target.value)}
              placeholder="https://sei.catolicaorione.edu.br/webservice/financeiro/gerarBoletoAvulso"
              helperText="URL da criação do boleto (POST, parâmetros no corpo). NÃO é a URL do PIX." />
          </Grid>
          <Grid size={{ xs: 6, sm: 3 }}><TextField fullWidth label="Conta corrente" value={cfg.ErpPix.ContaCorrente || ""} onChange={(e) => set("ErpPix", "ContaCorrente", e.target.value)} /></Grid>
          <Grid size={{ xs: 6, sm: 3 }}><TextField fullWidth label="Unidade de ensino" value={cfg.ErpPix.UnidadeEnsino || ""} onChange={(e) => set("ErpPix", "UnidadeEnsino", e.target.value)} /></Grid>
          <Grid size={{ xs: 6, sm: 2 }}><TextField fullWidth label="Turma" value={cfg.ErpPix.Turma || ""} onChange={(e) => set("ErpPix", "Turma", e.target.value)} /></Grid>
          <Grid size={{ xs: 6, sm: 2 }}><TextField fullWidth label="Centro receita" value={cfg.ErpPix.CentroReceita || ""} onChange={(e) => set("ErpPix", "CentroReceita", e.target.value)} placeholder="15" /></Grid>
          <Grid size={{ xs: 6, sm: 2 }}><TextField fullWidth label="Dias p/ venc." value={cfg.ErpPix.DiasVencimento || ""} onChange={(e) => set("ErpPix", "DiasVencimento", e.target.value)} placeholder="3" /></Grid>

          <Grid size={{ xs: 12 }}>
            <Stack direction="row" alignItems="center" sx={{ mt: 1 }}>
              <Typography variant="subtitle2" color="primary" sx={{ flexGrow: 1 }}>Busca de matrícula (banco do SEI)</Typography>
              <Button size="small" variant="outlined" onClick={testarMatriculaFn}>Testar matrícula</Button>
            </Stack>
            <Divider />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <FormControlLabel control={<Checkbox checked={String(cfg.ErpPix.BuscarMatricula).toLowerCase() === "true"} onChange={(e) => set("ErpPix", "BuscarMatricula", e.target.checked ? "true" : "false")} />}
              label="Buscar a matrícula do aluno/responsável pelo CPF e enviá-la na geração do PIX" />
          </Grid>
          <Grid size={{ xs: 12 }}><Secret label="String de conexão (PostgreSQL SEIBD)" value={cfg.ErpPix.MatriculaConnString} onChange={(e) => set("ErpPix", "MatriculaConnString", e.target.value)} /></Grid>
        </Grid>
      </Paper>

      <Box sx={{ textAlign: "right" }}>
        <Button variant="contained" onClick={salvar} disabled={salvando}>{salvando ? "Salvando…" : "Salvar tudo"}</Button>
      </Box>
    </Box>
  );
}
